import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ClonedUser } from 'src/app/admin/models/cloned-user.model';
import { UserAccount } from 'src/app/admin/models/user-account.model';

export const CloneUserActions = createActionGroup({
    source: 'Clone User Component',
    events: {
        getUsersByName: props<{ name: string; companyId: number }>(),
        setCloneCoreApiPermissions: props<{ cloneCoreApiPermissions: boolean }>(),
        createClone: props<{ userInfo: unknown }>(),
        clearClone: emptyProps(),
        clearCloneSuccess: props<{ clonedUser: ClonedUser }>()
    }
});

export const CloneApiActions = createActionGroup({
    source: 'Clone User API',
    events: {
        getUsersByNameSuccess: props<{ employee: UserAccount[] }>(),
        getUsersByNameFailure: props<{ error: unknown }>(),
        userHasCloneRestrictedPermissionSuccess: props<{ hasCloneRestrictedPermission: boolean }>(),
        userHasCloneRestrictedPermissionFailure: props<{ error: unknown }>(),
        createCloneSuccess: props<{ clonedUser: ClonedUser }>(),
        createCloneFailure: props<{ error: unknown }>()
    }
});
